import { useEffect, useState } from 'react';
import { api } from '../../lib/auth';

const cache = new Map();

export function useAuthImage(src) {
  const [url, setUrl] = useState(cache.get(src) || null);
  useEffect(() => {
    if (!src || cache.has(src)) { setUrl(cache.get(src) || null); return undefined; }
    let on = true;
    api.get(src, { responseType: 'blob' }).then((r) => { const u = URL.createObjectURL(r.data); cache.set(src, u); if (on) setUrl(u); }).catch(() => {});
    return () => { on = false; };
  }, [src]);
  return url;
}

export function AuthImg({ src, className, alt = '', testId }) {
  const url = useAuthImage(src);
  return url ? <img src={url} alt={alt} className={className} data-testid={testId} /> : <div className={`${className} bg-slate-100 animate-pulse`} />;
}

export const money = (n) => (n == null || Number.isNaN(n) ? '—' : `€ ${Number(n).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const num = (v) => { if (v === '' || v == null) return null; const n = Number(String(v).replace(',', '.')); return Number.isFinite(n) ? n : null; };
